import ReactDOM from 'react-dom'
import React from 'react'

import '../../../common/general/css/General.less'
import FIC from 'common/general/js/FIC'
import App from './App'
import HelpInternal from '../../internal/js/HelpInternal'

FIC.init()

const props = {}
var ExternalApp = App
if (reactInitParams.embedded) {
  ExternalApp = HelpInternal
  props.loadData = true
  props.embedded = true
  props.realm = reactInitParams.realm
  reactGlobalParams.chat.help_visible = false
}

ReactDOM.render(<ExternalApp globals={reactGlobalParams} params={reactInitParams} {...props} />, document.getElementById('react-wrapper-root'))



// WEBPACK FOOTER //
// ./src/help/external/js/index.js